var exports = {
  "k": "x4ddf2309--859d20--container",
  "x": "x4ddf2309--859d20--button",
};

module.exports = exports;
